import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ScrollToTop from '../Components/ScrollToTop'
import AboutOne from '../Components/About/AboutOne'

function About() {
    return (
        <>
            <Breadcrumb
                title="About Tourm"
            />
            <AboutOne />
            <ScrollToTop />
        </>
    )
}

export default About
